import { createSlice } from '@reduxjs/toolkit';
import add from 'lodash/add';
import set from 'lodash/set';

const initialState = {
    activeCampus: null,
  allCampuses: [],
  isLoading: false,
};

const MetaSlice = createSlice({
    name: 'meta',
    initialState,
    reducers: {
        setActiveCampus: (state, action) => {
            state.activeCampus = action.payload;
            // Persist to localStorage as backup
            localStorage.setItem('activeCampus', JSON.stringify(action.payload));
          },
          setAllCampuses: (state, action) => {
            state.allCampuses = action.payload;
          },
        },
      });

export const { setActiveCampus, setAllCampuses } = MetaSlice.actions;

export default MetaSlice.reducer;
